import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Dashboard from "../../Pages/User/Dashboard";
import EmailServers from "../../Pages/User/EmailServers";
import PaymentDetails from "../../Pages/User/PaymentDetails";
import APIKeys from "../../Pages/User/APIkeys";
import AddEmailServer from "../../Pages/User/AddEmailServer";
import EditEmailServer from "../../Pages/User/EditEmailServer";
import CreateApiKey from "../../Pages/User/CreateApiKey";
import APIKeyGenerated from "../../Pages/User/APIKeyGenerated";
import PricingPlan from "../../Pages/User/PricingPlan";
import Profile from "../../Pages/User/Profile";
import EditProfile from "../../Pages/User/EditProfile";
import ChangePassword from "../../Pages/User/ChangePassword";

const UserRoutes = ({ setUser }) => {
  return (
    <Routes>
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/email-servers" element={<EmailServers />} />
      <Route path="/add-email-server" element={<AddEmailServer />} />
      <Route path="/edit-email-server" element={<EditEmailServer />} />
      <Route path="/api-keys" element={<APIKeys />} />
      <Route path="/api-key-generated" element={<APIKeyGenerated />} />
      <Route path="/create-api-key" element={<CreateApiKey />} />
      <Route path="/payment-details" element={<PaymentDetails />} />
      <Route path="/pricing-plan" element={<PricingPlan />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/edit-profile" element={<EditProfile />} />
      <Route path="/change-password" element={<ChangePassword />} />

      <Route path="*" element={<Navigate to="/dashboard" />} />
    </Routes>
  );
};

export default UserRoutes;
